const NProgress = require('nprogress')

class ProgressBar {
    start() {
        NProgress.start();
    }
    done() {
        NProgress.done();
    }
}

export default new ProgressBar(); 